import { render, staticRenderFns } from "./CheckLanguage.vue?vue&type=template&id=74fc8fb8&scoped=true"
import script from "./CheckLanguage.vue?vue&type=script&lang=js"
export * from "./CheckLanguage.vue?vue&type=script&lang=js"
import style0 from "./CheckLanguage.vue?vue&type=style&index=0&id=74fc8fb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74fc8fb8",
  null
  
)

export default component.exports